<template lang="pug">
.container-fluid
	.itemCategoria(v-for="cat in listadoItems" :key="cat.nombre")
		.card.mb-4
			.card-header.bg-warning.text-white
				span.mr-2(:class="cat.icono")
				| {{cat.nombre}}
			.card-body
				.itemPanel.text-info(v-for="item in cat.items" :key="item.path" @click="go(item.path)")
					span(:class="item.icono" style="font-size:5em;")
					br
					b {{ item.nombre }}
</template>

<script>
import axios from 'axios'

export default {
	data () {
		return {
			listadoItems: []
		}
	},
	created () {
		this.getItems()
	},

	methods: {
		getItems () {
			axios.get('core/php/api/panel/getItems.php')
				.then(res => {
					this.listadoItems = res.data.items.items
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		go (path) {
			this.$router.push(path)
		}
	}
}
</script>

<style scoped>
	.itemPanel {
		position: relative;
		display: inline-block;
		text-align: center;
		margin: 15px;
		cursor: pointer;
		max-width: 150px;
		vertical-align:top;
		opacity: 0.7;
	}

	.itemPanel:hover {
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/panel-control/menu.vue